import AppCard from 'components/layouts/app-card';

import {getInputPlaceHolder} from 'utils/message-helper';
import {Button, Divider, Typography} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import {useFormContext} from 'react-hook-form';
import AppInput from '../controles/input';

const ContactDetailsForm = ({onContinue}) => {
  const {trigger} = useFormContext();
  const onSubmit = async () => {
    const isValid = await trigger([
      'first_name',
      'last_name',
      'email_address',
      'password',
    ]);
    if (isValid) {
      onContinue();
    }
  };

  return (
    <AppCard className='bg-[#FFFFFF6B] p-5'>
      <div className='flex flex-col items-center'>
        <Typography.Title>Let's get started</Typography.Title>
        <Typography.Paragraph className='!mb-10'>
          To create your account, we just need a few details.
        </Typography.Paragraph>
        <AppInput
          name='first_name'
          label='First Name'
          isRequired
          placeholder={getInputPlaceHolder('first name')}
        />
        <AppInput
          name='last_name'
          label='Last Name'
          isRequired
          placeholder={getInputPlaceHolder('last name')}
        />
        <AppInput
          name='email_address'
          label='Work Email'
          isRequired
          placeholder={getInputPlaceHolder('email address')}
        />
        <AppInput
          isRequired
          name='password'
          label='Password'
          type='password'
          placeholder={getInputPlaceHolder('password')}
          classes={{
            root: 'mb-10',
          }}
        />
        <Typography.Paragraph className='text-xs max-w-[480px] !mb-10'>
          By signing up and using the services, you confirm that you have
          accepted our{' '}
          <a
            href='https://sourcer.com/legal/terms-of-service'
            target='_blank'
            rel='noreferrer'>
            Terms of Service
          </a>{' '}
          and have read our{' '}
          <a
            href='https://sourcer.com/legal/privacy-policy'
            target='_blank'
            rel='noreferrer'>
            Privacy Policy
          </a>
          .
        </Typography.Paragraph>
        <Button
          onClick={onSubmit}
          type='primary'
          size='large'
          className='mb-10 bg-[#EC8350] w-full max-w-[480px] hover:!bg-[#EC8350] hover:opacity-45'>
          Create Account
        </Button>
        <Typography.Paragraph>
          Would like to see a demo first?{' '}
          <a
              rel="noopener noreferrer"
              target='_top'
            href='https://sourcer.com/request-client-demo'
            className='!text-[#EC8350]'>
            Request a demo
          </a>
        </Typography.Paragraph>
        <Divider className='bg-[#EC8350] my-10' />
        <Typography.Paragraph>
          Are you a talent supplier?{' '}
          <a
              rel="noopener noreferrer"
              target='_top'
            href='https://sourcer.com/supplier-registration'
            className='!text-[#EC8350]'>
            Register today
          </a>
        </Typography.Paragraph>
      </div>
    </AppCard>
  );
};

ContactDetailsForm.propTypes = {
  onContinue: PropTypes.func,
};

export default React.memo(ContactDetailsForm);
